import type { FunctionComponent } from 'react';
import classNames from 'classnames';
import { Typography } from '@andes/typography';
import { PageContextType, usePage } from '../../../../contexts/PageContext';
import type { ViewProps } from '../Hub';

type B2BComponentWordingType = Exclude<Required<ViewProps['wordings']['hubB2bWordings']>, undefined>;
interface HubFooterProps {
  wordings: B2BComponentWordingType,
  urls: ViewProps['urls'],
}

export const B2BComponent: FunctionComponent<HubFooterProps> = ({ wordings, urls }) => {
  const { isMobile } = usePage() as PageContextType;

  return (
    <div className={classNames('hub-footer', { 'hub-footer--mobile': isMobile })}>
      <div className="hub-footer__container">
        <Typography>{wordings.corporative_account_question}</Typography>
        <Typography
          component="a"
          href={urls.b2b}
        >{ wordings.create_corporative_account }
        </Typography>
      </div>
    </div>
  );
};
